<!-- 上传图片并裁剪 -->
<template>
  <div :style="{ marginTop: marginTop + 'px' }">
    <!-- 上传 -->
    <template>
      <!-- <el-button type="primary" @click="openCropperDialog">裁剪图片</el-button> -->
      <!-- <div
        class="preview-img"
        v-show="previewImg"
        :style="{ width: uploadWidth + 'px', height: uploadHeight + 'px' }"
      >
        <div class="preview-img-box" :style="{ lineHeight: uploadHeight + 'px' }">
          <i class="el-icon-delete" @click="deleteFn"></i>
          <i class="el-icon-view" @click="viewFn"></i>
          <i class="el-icon-refresh" @click="refreshFn"></i>
        </div>
        <div class="preview-img-number">
          <slot name="preview-img-number"></slot>
        </div>
        <img :src="previewImg" :style="{ width: '100%', height: '100%', objectFit: objectFit }" />
      </div> -->
      <div style="display: flex;align-items: flex-end;">
        <video v-if="uploadType == 'video'" ref="videoPlayer" style="width: 500px;height:400px" @ended="onVideoEnded" controls muted>
          <source :src="previewImg" type="video/mp4">
          Your browser does not support the video tag.
        </video>
        <el-upload
          ref="upload"
          class="upload-demo"
          :action="actionUrl"
          :on-change="handleChangeUpload"
          :auto-upload="false"
          :show-file-list="false"
          :disabled="disabled"
        >
        <div v-if="previewImg && uploadType != 'video'" class="image-upload-list-item" style="margin-top: 10px;">
          <el-image v-if="disabled" :src="previewImg" class="upload-image-size" fit="cover" :preview-src-list="[previewImg]" lazy></el-image>
          <el-image  v-else :src="previewImg" class="upload-image-size" fit="cover" lazy></el-image>
          <div
              v-if="!disabled"
              class="image-upload__item-actions"
            >
              <span class="del" @click.stop="deleteFn()">
                <i class="el-icon-delete"></i>
              </span>
            </div>
        </div>
        <div v-else class="el-upload--picture-card " style="margin-top: 10px;">
          <i class="el-icon-plus avatar-uploader-icon"></i>
        </div>
        <template #tip>
          <div v-if="tip" class="el-upload__tip">{{ tip }}</div>
        </template>
        </el-upload>
        <el-button v-if="uploadType == 'gif' || uploadType == 'video'" type="danger" plain @click="clearVioeo">删除视频</el-button>
        <span v-if="uploadType == 'gif' || uploadType == 'video'" class="tipUpload ml16">*由于上传格式不是jpg,png，所以裁剪功能不能使用</span>
      </div>
    </template>
    <!-- 裁剪 -->
    <el-dialog title="图片剪裁" :visible.sync="dialogVisible" class="crop-dialog" append-to-body>
      <div style="padding: 0 20px">
        <div
          :style="{
            textAlign: 'center',
            width: cropperWidth != 0 ? cropperWidth + 'px' : 'auto',
            height: cropperHeight + 'px',
          }"
        >
          <VueCropper
            ref="cropper"
            :img="cropperImg"
            :output-size="outputSize"
            :output-type="outputType"
            :info="info"
            :full="full"
            :can-move="canMove"
            :can-move-box="canMoveBox"
            :original="original"
            :auto-crop="autoCrop"
            :can-scale="canScale"
            :fixed="fixed"
            :fixed-number="fixedNumber"
            :fixed-box="fixedBox"
            :center-box="centerBox"
            :info-true="infoTrue"
            :auto-crop-width="autoCropWidth"
            :auto-crop-height="autoCropHeight"
          />
        </div>
      </div>
      <!-- 这里的按钮可以根据自己的需求进行增删-->
      <div class="action-box" v-if="actionButtonFlag">
        <el-upload
          action="#"
          :auto-upload="false"
          :show-file-list="false"
          :on-change="handleChangeUpload"
          style="margin-right: 15px"
        >
          <el-button type="primary">更换图片</el-button>
        </el-upload>
        <el-button type="primary" @click="clearImgHandle">清除图片</el-button>
        <el-button type="primary" @click="rotateLeftHandle">左旋转</el-button>
        <el-button type="primary" @click="rotateRightHandle">右旋转</el-button>
        <el-button type="primary" plain @click="changeScaleHandle(2)">放大</el-button>
        <el-button type="primary" plain @click="changeScaleHandle(-2)">缩小</el-button>
        <el-button type="primary" @click="fixed = !fixed">{{ fixed ? "固定比例" : "自由比例" }}</el-button>
        <!-- <el-button type="primary" @click="downloadHandle('blob')">下载</el-button> -->
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="loading" @click="finish">确认</el-button>
      </div>
    </el-dialog>
    <!-- 预览 -->
    <el-dialog title="图片预览" :visible.sync="previewDialogVisible" append-to-body>
      <img :src="previewImg" style="width: 100%" />
      <div slot="footer" style="text-align: center">
        <el-button @click="previewDialogVisible = false" type="primary">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>
 
<script>
import { VueCropper } from 'vue-cropper'
import config from './config'
import dayjs from 'dayjs'
import { Loading } from 'element-ui'
//   import { xxxx } from '@/api/xxx' // 后端接口
export default {
  name: 'Cropper',
  components: {
    VueCropper
  },
  props: {
    tip: { type: String, default: '' },
    maxSize: { type: Number, default: config.maxSize },
    maxVideoSize: { type: Number, default: config.maxSize },
    otherPrams: { type: Object, default: () => {} },
    ifSetUploadName: { type: Boolean, default: false },
    updateParams: {
      type: Object,
      default: () => {
        return {
          fileName: '',
          tip: '',
          code: ''
        }
      }
    },
    marginTop: {
      type: Number,
      default: 0
    },
    // 图片路径
    imgSrc: {
      type: String,
      default: ''
    },
    // 是否禁用
    disabled: {
      type: Boolean,
      default: false
    },
    // 列表索引
    listIndex: {
      type: Number,
      default: null
    },
    // 上传路径
    actionUrl: {
      type: String,
      default: '#'
    },
    // 上传宽度
    uploadWidth: {
      type: Number,
      default: 100
    },
    // 上传高度
    uploadHeight: {
      type: Number,
      default: 100
    },
    // 图片显示角度 传值详情参考mdn object-fit
    objectFit: {
      type: String,
      default: 'fill'
    },

    // 裁剪属性

    // 裁剪弹出框的宽度
    cropperWidth: {
      type: Number,
      default: 0
    },
    // 裁剪弹出框的高度
    cropperHeight: {
      type: Number,
      default: 600
    },
    // 裁剪生成图片的质量 0.1-1
    outputSize: {
      type: Number,
      default: 1
    },
    // 裁剪生成图片的格式
    outputType: {
      type: String,
      default: 'png'
    },
    // 裁剪框的大小信息
    info: {
      type: Boolean,
      default: true
    },
    // 是否输出原图比例的截图
    full: {
      type: Boolean,
      default: true
    },
    // 截图框能否拖动
    canMove: {
      type: Boolean,
      default: true
    },
    // 截图框能否拖动
    canMoveBox: {
      type: Boolean,
      default: true
    },
    // 上传图片按照原始比例渲染
    original: {
      type: Boolean,
      default: true
    },
    // 是否默认生成截图框
    autoCrop: {
      type: Boolean,
      default: true
    },
    // 图片是否允许滚轮缩放
    canScale: {
      type: Boolean,
      default: true
    },
    // 是否开启截图框宽高固定比例
    fixed: {
      type: Boolean,
      default: false
    },
    // 截图框的宽高比例 开启fixed生效
    fixedNumber: {
      type: Array,
      default: () => [16, 7]
    },
    // 固定截图框大小 不允许改变
    fixedBox: {
      type: Boolean,
      default: false
    },
    // 截图框是否被限制在图片里面
    centerBox: {
      type: Boolean,
      default: true
    },
    // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
    infoTrue: {
      type: Boolean,
      default: true
    },
    // 默认生成截图框宽度
    autoCropWidth: {
      type: Number,
      default: 480
    },
    // 默认生成截图框高度
    autoCropHeight: {
      type: Number,
      default: 270
    },
    // 是否出现操作按钮
    actionButtonFlag: {
      type: Boolean,
      default: false
    },
    // 裁剪路径输出格式 base64：base64； blob:blob
    cropFormat: {
      type: String,
      default: 'blob'
    },
    // 裁剪路径
    cropperImgUrl: {
      type: String,
      default: ''
    },
    // 图片最大宽度
    maxImgWidth: {
      type: Number,
      default: 648
    },
    // 图片最大高度
    maxImgHeight: {
      type: Number,
      default: 1152
    }
  },
  data () {
    return {
      previewImg: '', // 预览图片地址
      dialogVisible: false, // 图片裁剪弹框
      cropperImg: '', // 裁剪图片的地址
      loading: false, // 防止重复提交
      previewDialogVisible: false, // 预览弹框
      uploadType: 'image'
    }
  },
  watch: {
    imgSrc: {
      handler (newVal, oldVal) {
        this.uploadType = 'image'
        if (!newVal === false) {
          this.$nextTick(() => {
            this.previewImg = this.setUrlHearder(newVal)
            this.uploadType = this.previewImg.includes('.mp4') ? 'video' : this.previewImg.includes('.gif') ? 'gif' : 'image'
          })
        }
      },
      deep: true // 深度监听
      // immediate: true // 首次进入就监听
    },
    cropperImgUrl: {
      handler (newVal, oldVal) {
        this.cropperImg = newVal
      },
      deep: true, // 深度监听
      immediate: true // 首次进入就监听
    }
  },
  methods: {
    // 拼接url
    setUrlHearder (url) {
      if (!url) return
      return url.indexOf('http') >= 0 ? url : process.env.VUE_APP_SERVER_URL + url
    },
    resetFields () {
      this.previewImg = ''
      this.uploadType = 'image'
    },
    onVideoEnded () {
      this.$refs.videoPlayer.play()
    },
    // 上传按钮 限制图片大小和类型
    handleChangeUpload (file) {
      let maxUploadSize = this.maxSize
      let maxSizeTip = '图片'
      if (file.raw.type === 'video/mp4') {
        maxUploadSize = this.maxVideoSize
        maxSizeTip = '视频'
      }
      if (this.ifSetUploadName && !this.updateParams.fileName) {
        this.$message.error(this.updateParams.tip)
        return false
      }
      const isJPG =
        file.raw.type === 'image/jpeg' || file.raw.type === 'image/png' || file.raw.type === 'image/gif' || file.raw.type === 'video/mp4'
      const isLt2M = file.size / 1024 / 1024 < Number(maxUploadSize)
      if (!isJPG) {
        this.$message.error('上传图片或视频只能是 JPG/PNG/GIF/mp4 格式!')
        return false
      }
      if (!isLt2M) {
        this.$message.error('上传' + maxSizeTip + '大小不能超过 ' + maxUploadSize + 'MB!')
        return false
      }
      if (file.raw.type === 'image/gif') {
        this.uploadType = 'gif'
        this.uploadImage(file.raw, file.name)
      } else if (file.raw.type === 'video/mp4') {
        this.uploadType = 'video'
        this.uploadImage(file.raw, file.name)
      } else {
        this.uploadType = 'image'
        // 上传成功后将图片地址赋值给裁剪框显示图片
        this.$nextTick(async () => {
          // base64方式
          // this.option.img = await fileByBase64(file.raw)
          this.cropperImg = URL.createObjectURL(file.raw)
          this.loading = false
          this.dialogVisible = true
        })
      }
    },
    openCropperDialog () {
      this.loading = false
      this.dialogVisible = true
    },
    // 放大/缩小
    changeScaleHandle (num) {
      num = num || 1
      this.$refs.cropper.changeScale(num)
    },
    // 左旋转
    rotateLeftHandle () {
      this.$refs.cropper.rotateLeft()
    },
    // 右旋转
    rotateRightHandle () {
      this.$refs.cropper.rotateRight()
    },
    // 下载
    downloadHandle (type) {
      let aLink = document.createElement('a')
      aLink.download = 'author-img'
      if (type === 'blob') {
        this.$refs.cropper.getCropBlob(data => {
          aLink.href = URL.createObjectURL(data)
          aLink.click()
        })
      } else {
        this.$refs.cropper.getCropData(data => {
          aLink.href = data
          aLink.click()
        })
      }
    },
    // 清理图片
    clearImgHandle () {
      this.cropperImg = ''
    },
    // 截图
    finish () {
      if (this.cropFormat === 'base64') {
        // 获取截图的 base64 数据
        this.$refs.cropper.getCropData(data => {
          this.loading = true
          this.dialogVisible = false

          this.getImgHeight(data, this.maxImgWidth, this.maxImgHeight).then(
            imgUrl => {
              this.previewImg = imgUrl
              if (this.listIndex !== null) {
                this.$emit('successCheng', this.previewImg, this.listIndex)
              } else {
                this.$emit('successCheng', this.previewImg)
              }
            }
          )
        })
      } else if (this.cropFormat === 'blob') {
        // 获取截图的 blob 数据
        this.$refs.cropper.getCropBlob(blob => {
          this.loading = true
          this.dialogVisible = false

          // this.getImgHeight(
          //   URL.createObjectURL(blob),
          //   this.maxImgWidth,
          //   this.maxImgHeight
          // ).then(imgUrl => {
          //   // console.log(imgUrl, "blob")
          //   this.previewImg = imgUrl
          //   if (this.listIndex !== null) {
          //     this.$emit("successCheng", this.previewImg, this.listIndex)
          //   } else {
          //     this.$emit("successCheng", this.previewImg)
          //   }
          // })

          this.uploadImage(blob)
        })
      }
    },
    // 上传到后端
    uploadImage (blob, name) {
      var apiObj = config.apiObj
      if (this.apiObj) {
        apiObj = this.apiObj
      }
      let file = null
      if (this.uploadType === 'image') {
        file = new File([blob], dayjs() + '.png', {
          type: 'image/png',
          lastModified: Date.now()
        })
      } else {
        file = new File([blob], name, {
          type: 'image/gif',
          lastModified: Date.now()
        })
      }
      file.uid = Date.now()
      var fd = new FormData()
      if (this.ifSetUploadName) {
        let uploadName = this.getFileExtension(file.name)
        var fileNew = new File([file], uploadName)
        fd.append('file', fileNew)
      } else {
        fd.append('file', file)
      }
      // let params = {
      //   uploadPath: 'userdir'
      // }
      let params = {
        id: this.otherPrams ? this.otherPrams.id : '',
        type: this.otherPrams ? this.otherPrams.type : '',
        uploadPath: 'userdir'
      }
      if (this.uploadType !== 'image') {
        params.maxFileSize = this.maxVideoSize ? this.maxVideoSize : 200
      }

      const loading = Loading.service({
        text: config.loadingText || 'Loading...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      apiObj
        .uploadFileUrl(fd, params, {
          onUploadProgress: e => {
            // const complete = parseInt(((e.loaded / e.total) * 100) | 0, 10)
            // param.onProgress({ percent: complete })
          }
        })
        .then(res => {
          // param.onSuccess(res)
          this.previewImg = process.env.VUE_APP_SERVER_URL + res.data
          let userObj = JSON.parse(localStorage.getItem('user'))
          let num = res.data.lastIndexOf('name=')
          let subName = res.data.substring(num + 5)
          let lastDotIndex = subName.lastIndexOf('.')
          let subNameNoType = subName.substring(0, lastDotIndex)
          let fileObj = {
            url: this.previewImg,
            actorName: userObj.name,
            actorId: userObj.id,
            fileName: subName,
            filePath: res.data,
            name: subNameNoType,
            size: file.size
          }
          this.$emit('updateChange', fileObj)
          loading.close()
        }).catch(() => {
          loading.close()
        })
    },
    clearVioeo () {
      this.previewImg = ''
      this.$emit('updateChange')
    },
    getFileExtension (fileName) {
      let uploadName = this.updateParams.fileName.replace(/\s+/g, '_')
      let num = 1
      // 使用 lastIndexOf 方法找到最后一个点的位置
      let lastDotIndex = fileName.lastIndexOf('.')
      // 如果没有找到点，返回空字符串或适当的默认值
      if (lastDotIndex === -1) return ''
      // 截取从点到字符串末尾的部分作为扩展名
      let extension = fileName.substring(lastDotIndex)
      // 返回扩展名
      return `${uploadName}_${this.updateParams.code}_${num}${extension}`
    },
    // 预览图片
    viewFn () {
      this.previewDialogVisible = true
    },
    // 删除图片
    deleteFn () {
      this.previewImg = ''
      if (this.listIndex !== null) {
        this.$emit('deleteCheng', '', this.listIndex)
      } else {
        this.$emit('deleteCheng', '', '')
      }
      this.$emit('updateChange', '')
    },
    // 更换图片
    refreshFn () {
      this.$refs['upload'].$refs['upload-inner'].handleClick()
    },
    // 获取图片高度并修改
    getImgHeight (imgSrc, scaleWidth = 648, scaleHeight = 1152) {
      return new Promise((resolve, reject) => {
        const img = new Image() // 创建一个img对象
        img.src = imgSrc // 设置图片地址
        let imgUrl = '' // 接收图片地址
        img.onload = () => {
          if (img.width > scaleWidth || img.height > scaleHeight) {
            const canvas = document.createElement('canvas')
            const context = canvas.getContext('2d')
            canvas.width = scaleWidth
            canvas.height = scaleHeight
            context.drawImage(img, 0, 0, scaleWidth, scaleHeight)
            if (this.cropFormat === 'blob') {
              imgUrl = this.base64toBlob(
                canvas.toDataURL('image/png', 1),
                'image/png'
              )
            } else {
              imgUrl = canvas.toDataURL('image/png', 1)
            }
            resolve(imgUrl)
          } else {
            imgUrl = imgSrc
            resolve(imgUrl)
          }
        }
      })
    },
    // base64转blob
    base64toBlob (base64, type = 'application/octet-stream') {
      // 去除base64头部
      // const images = base64.replace(/^data:image\/\w+base64,/, "")
      // console.log(base64, '12312')
      const bstr = window.atob(base64.split(',')[1])
      let n = bstr.length
      const u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return URL.createObjectURL(new Blob([u8arr], { type }))
    }
  }
}
</script>
 
<style lang="scss" scoped>
.preview-img {
  position: relative;
  cursor: pointer;
 
  &:hover {
    .preview-img-box {
      display: block
    }
  }
}
 
.preview-img-box {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  background-color: rgba(30, 28, 28, 0.5);
  display: none;
  color: #d9d9d9;
  font-size: 24px;
  text-align: center;
}
 
.preview-img-number {
  width: 20px;
  height: 20px;
  overflow: hidden;
  position: absolute;
  right: 0;
  bottom: 0;
  background-color: rgba(8, 137, 53, 1);
  color: #d9d9d9;
  font-size: 20px;
  text-align: center;
  border-radius: 50%;
}
 
.upload-demo {
  // border: 1px dashed #d9d9d9;
  // border-radius: 6px;
  // cursor: pointer;
  margin: 0 10px;
}
 
.upload-demo-icon {
  font-size: 60px;
  color: #8c939d;
  text-align: center;
}
 
.crop-dialog {
  .action-box {
    margin: 20px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
 
    button {
      margin-top: 15px;
      // width: 80px;
      margin-right: 15px;
    }
  }
 
  .dialog-footer {
    text-align: center;
 
    button {
      width: 100px;
    }
  }
}
.el-form-item.is-error .image-upload-multiple:deep(.el-upload--picture-card) {
	border-color: var(--el-color-danger);
}
:deep(.el-upload-list__item) {
	transition: none;
	border-radius: 0;
}
.image-upload-multiple:deep(.el-upload-list__item.el-list-leave-active) {
	position: static !important;
}
.image-upload-multiple:deep(.el-upload--picture-card) {
	border-radius: 0;
}
.image-upload-list-item {
	width: 100%;
	height: 100%;
	position: relative;
}
.image-upload-list-item:hover .image-upload__item-actions {
	display: block;
}
.image-upload-multiple .el-image {
	display: block;
}
.image-upload-multiple .el-image:deep(img) {
	-webkit-user-drag: none;
}
.image-upload-multiple-image-slot {
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
	height: 100%;
	font-size: 12px;
}
.image-upload-multiple .el-upload-list__item:hover .image-upload__item-actions {
	display: block;
}
.image-upload__item-actions {
	position: absolute;
	top: 0;
	right: 0;
	display: none;
}
.image-upload__item-actions span {
	display: flex;
	justify-content: center;
	align-items: center;
	width: 25px;
	height: 25px;
	cursor: pointer;
	color: #fff;
}
.image-upload__item-actions span i {
	font-size: 12px;
}
.image-upload__item-actions .del {
	background: #f56c6c;
}
.image-upload__item-progress {
	position: absolute;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	background-color: var(--el-overlay-color-lighter);
}
.upload-image-size{
  width: 150px;
  height: 150px;
}
.tipUpload{
  font-size: 12px;
  color: red;
}
</style>